import React from 'react';
import { IconButton, Typography } from '@mui/material';
import { useLanguageContext } from '../contexts/LanguageContext';

interface LanguageToggleProps {
  variant?: 'light' | 'dark';
  size?: 'small' | 'medium' | 'large';
}

const LanguageToggle: React.FC<LanguageToggleProps> = ({ 
  variant = 'light', 
  size = 'medium' 
}) => {
  const { toggleLanguage, currentLanguage } = useLanguageContext();

  const buttonSize = {
    small: 32,
    medium: 40,
    large: 48
  }[size];

  const fontSize = {
    small: '0.75rem',
    medium: '0.875rem',
    large: '1rem'
  }[size];

  return (
    <IconButton
      onClick={toggleLanguage}
      sx={{
        width: buttonSize,
        height: buttonSize,
        borderRadius: 2,
        backgroundColor: variant === 'light' 
          ? 'rgba(255, 255, 255, 0.9)' 
          : 'rgba(0, 0, 0, 0.7)',
        color: variant === 'light' ? '#6F4E37' : 'white',
        backdropFilter: 'blur(10px)',
        border: '1px solid',
        borderColor: variant === 'light' 
          ? 'rgba(0, 0, 0, 0.1)' 
          : 'rgba(255, 255, 255, 0.2)',
        '&:hover': {
          backgroundColor: variant === 'light' 
            ? 'rgba(255, 255, 255, 1)' 
            : 'rgba(0, 0, 0, 0.8)',
          transform: 'translateY(-1px)',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
        },
        transition: 'all 0.2s ease',
      }}
    >
      <Typography 
        variant="caption" 
        sx={{ 
          fontWeight: 'bold',
          fontSize,
          lineHeight: 1
        }}
      >
        {currentLanguage === 'ko' ? 'ENG' : 'KO'}
      </Typography>
    </IconButton>
  );
};

export default LanguageToggle;